module.exports = __webpack_public_path__ + "static/aplinkos-ministerija-7ef93218be4b21189432989cb2558980.svg";